import React, { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";
import Box from "@mui/material/Box";
import PostConfirmationMessage from "components/layout/post-confirmation";
import { Divider } from "@mui/material";
import Blog from "components/layout/main/blog/Blog";
import Header from "components/layout/header/Header";
import Footer from "components/layout/footer/Footer";

const SurveyPage = () => {
  const { user } = useAuth();
  useEffect(() => {
    // Scroll to the top when the component mounts or updates
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 4,
      }}
    >
      <Header />
      <Box my={4} className="secondBackground">
        <div className="maxWidth marginAuto">
          <div className="separatorEmptyLarge"></div>
          <PostConfirmationMessage userType={user.userType ?? user.usertype} />
          <div className="separatorEmptyLarge"></div>
          <Divider variant="middle" />
          <div className="separatorEmptyLarge"></div>
          <Blog />
        </div>
      </Box>
      <Footer />
    </Box>
  );
};

export default SurveyPage;
